import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import Account from "./components/Account";
import Activate from "./components/Activate";
import Dashboard from "./components/Dashboard";
import ForgotPassword from "./components/ForgotPassword";
import Login from "./components/Login";
import ResetPassword from "./components/ResetPassword";
import Signup from "./components/Signup";
import SignupSuccess from "./components/SignupSuccess";
import UpdatePassword from "./components/UpdatePassword";
import VerifyEmail from "./components/VerifyEmail";

import AddCompany from "./components/AddCompany";
import AddLocation from "./components/AddLocation";
import AddUsers from "./components/AddUsers";
import AppLogout from "./components/AppLogout";
import CandidateSearchView from "./components/Candidates/Search/CandidateSearchView";
import NewCandidateSearch from "./components/Candidates/Search/NewCandidateSearch";
import NewCandidateSearchV2 from "./components/Candidates/Search/NewCandidateSearchV2";
import SearchwithCriteria from "./components/Candidates/Search/SearchwithCriteria";
import SearchwithCriteriaV2 from "./components/Candidates/Search/SearchwithCriteriaV2";
import Contacts from "./components/Contacts";
import EmployerRegister from "./components/EmployerRegister";
import JobListing from "./components/JobListing";
import Jobmessages from "./components/jobmessages";
import JobOpportunity from "./components/JobOpportunity";
import JobSummary from "./components/JobOpportunity/Summary";
import Locations from "./components/Locations";
import LocationWithMap from "./components/Maps";
import MatchingCandidate from "./components/MatchingCandidate";
import EmployerProfile from "./components/Profile";
import ShiftsCoverage from "./components/ShiftsCoverage";
import AwaitingShiftsCoverage from "./components/ShiftsCoverage/awaitingShifts";
import CompletedShiftsCoverage from "./components/ShiftsCoverage/completedShifts";
import OpenShiftsCoverage from "./components/ShiftsCoverage/openShifts";
import User from "./components/User";

import { useEffect } from "react";
import AppClearCache from "./components/AppClearCache";
import ScrollTop from "./components/common/ScrollTop/ScrollTop";
import Messages from "./components/Messages";
import DailyEncounterInfo from "./components/ShiftsCoverage/dailyEncounterInfo";
import MultiShiftJobInfo from "./components/ShiftsCoverage/multiShiftJobInfo.js";
import Notification from "./components/Notification/Notification";
import AwaitingPayments from "./components/ShiftsCoverage/awaitingPayment";
import PowerBi from "./components/powerbi";
import EmployerSettings from "./components/EmployerSettings";
import Inbox from "./components/Inbox/Inbox";
import TextNotification from "./components/TextNotification/TextNotification.js";
import CreateTeam from "./components/CreateTeam/CreateTeam.js";
import ListTeams from "./components/CreateTeam/ListTeams.js";
// import TextNotification from "./components/TextNotification/TextNotification";
// import Phone from "./components/Twilio/Phone";
import Gps from './components/GpsIncident/Gps.js'
import Departments from "./components/Department/Departments.js";
import DepartmentsList from "./components/Department/DepartmentList.js";
import DomainIcons from "./components/Instance/DomainIcons.js";
import AwaitingCorrection from "./components/ShiftsCoverage/awaitingCorrection.js";
import TemplateList from "./components/JobOpportunity/templateList/TemplateList.js";



function App() {
  return (
    <Router>
      <DomainIcons/>
      <ScrollTop />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <AppLogout>
              <AppClearCache />
              <Dashboard />
            </AppLogout>
          }
        />
        <Route path="/signup" element={<Signup />} />
        <Route path="/signup/success" element={<SignupSuccess />} />

        <Route path="/forgot" element={<ForgotPassword />} />
        <Route
          path="/updatepassword"
          element={
            <AppLogout>
              <AppClearCache />
              <UpdatePassword />
            </AppLogout>
          }
        />
        <Route path="/resetpassword" element={<ResetPassword />} />
        <Route path="/activate" element={<Activate />} />
        <Route path="/verifyemail" element={<VerifyEmail />} />
        <Route path="/account" element={<Account />} />
        <Route path="*" element={<Login />} />

        <Route
          path="/addcompany"
          element={
            <AppLogout>
              <AppClearCache />
              <AddCompany />
            </AppLogout>
          }
        />
        <Route
          path="/locations"
          element={
            <AppLogout>
              <AppClearCache />
              <Locations />
            </AppLogout>
          }
        />
        <Route
          path="/addlocations"
          element={
            <AppLogout>
              <AppClearCache />
              <AddLocation />
            </AppLogout>
          }
        />
        <Route
          path="/contacts"
          element={
            <AppLogout>
              <AppClearCache />
              <Contacts />
            </AppLogout>
          }
        />
        <Route
          path="/adduser"
          element={
            <AppLogout>
              <AppClearCache />
              <AddUsers />
            </AppLogout>
          }
        />
        <Route
          path="/user"
          element={
            <AppLogout>
              <AppClearCache />
              <User />
            </AppLogout>
          }
        />
        <Route
          path="/employerProfile"
          element={
            <AppLogout>
              <AppClearCache />
              <EmployerProfile />
            </AppLogout>
          }
        />
        <Route
          path="/employerRegister"
          element={
            <AppLogout>
              <AppClearCache />
              <EmployerRegister />
            </AppLogout>
          }
        />
        <Route
          path="/newcandidatesearch"
          element={
            <AppLogout>
              <AppClearCache />
              <NewCandidateSearch />
            </AppLogout>
          }
        />
        <Route
          path="/jobopportunity"
          element={
            <AppLogout>
              <AppClearCache />
              <JobOpportunity />
            </AppLogout>
          }
        />
        <Route
          path="/template-list"
          element={
            <AppLogout>
              <AppClearCache />
              <TemplateList />
            </AppLogout>
          }
        />
        <Route
          path="/candidatesearchview"
          element={
            <AppLogout>
              <AppClearCache />
              <CandidateSearchView />
            </AppLogout>
          }
        />
        <Route
          path="/joblist"
          element={
            <AppLogout>
              <AppClearCache />
              <JobListing />
            </AppLogout>
          }
        />
        <Route
          path="/jobsummary"
          element={
            <AppLogout>
              <AppClearCache />
              <JobSummary />
            </AppLogout>
          }
        />
        <Route
          path="/searchwithcriteria"
          element={
            <AppLogout>
              <AppClearCache />
              <SearchwithCriteria />
            </AppLogout>
          }
        />
        <Route
          path="/matchingcandidate"
          element={
            <AppLogout>
              <AppClearCache />
              <MatchingCandidate />
            </AppLogout>
          }
        />
        <Route
          path="/shiftscoverage"
          element={
            <AppLogout>
              <AppClearCache />
              <ShiftsCoverage />
            </AppLogout>
          }
        />
        <Route
          path="/locationmaps"
          element={
            <AppLogout>
              <AppClearCache />
              <LocationWithMap />
            </AppLogout>
          }
        />
        <Route
          path="/openshifts"
          element={
            <AppLogout>
              <AppClearCache />
              <OpenShiftsCoverage />
            </AppLogout>
          }
        />
        <Route
          path="/awaitingcorrection"
          element={
            <AppLogout>
              <AppClearCache />
              <AwaitingCorrection />
            </AppLogout>
          }
        />
        <Route
          path="/completedshifts"
          element={
            <AppLogout>
              <AppClearCache />
              <CompletedShiftsCoverage />
            </AppLogout>
          }
        />
        <Route
          path="/awaitingshifts"
          element={
            <AppLogout>
              <AppClearCache />
              <AwaitingShiftsCoverage />
            </AppLogout>
          }
        />

        <Route
          path="/newcandidatesearchv2"
          element={
            <AppLogout>
              <AppClearCache />
              <NewCandidateSearchV2 />
            </AppLogout>
          }
        />
        <Route
          path="/searchwithcriteriav2"
          element={
            <AppLogout>
              <AppClearCache />
              <SearchwithCriteriaV2 />
            </AppLogout>
          }
        />
        <Route
          path="/messages"
          element={
            <AppLogout>
              <AppClearCache />
              <Messages />
            </AppLogout>
          }
        />
        <Route
          path="/inbox"
          element={
            <AppLogout>
              <AppClearCache />
              <Inbox />
            </AppLogout>
          }
        />
        <Route
          path="/texts"
          element={
            <AppLogout>
              <AppClearCache />
              <TextNotification />
            </AppLogout>
          }
        />
        <Route
          path="/jobmessages"
          element={
            <AppLogout>
              <AppClearCache />
              <Jobmessages />
            </AppLogout>
          }
        />
        <Route
          path="/multiShiftJobInfo"
          element={
            <AppLogout>
              <AppClearCache />
              <MultiShiftJobInfo />
            </AppLogout>
          }
        />
        <Route
          path="/daily-encounter-info"
          element={
            <AppLogout>
              <AppClearCache />
              <DailyEncounterInfo />
            </AppLogout>
          }
        />
        <Route
          path="/notifications"
          element={
            <AppLogout>
              <AppClearCache />
              <Notification />
            </AppLogout>
          }
        />
        <Route
          path="/awaitingpayments"
          element={
            <AppLogout>
              <AppClearCache />
              <AwaitingPayments />
            </AppLogout>
          }
        />
        <Route
          path="/powerbi"
          element={
            <AppLogout>
              <AppClearCache />
              <PowerBi />
            </AppLogout>
          }
        />
        {/* <Route
          path="/phone"
          element={
            <AppLogout>
              <AppClearCache />
              <Phone />
            </AppLogout>
          }
        /> */}
        <Route
          path="/employersettings"
          element={
            <AppLogout>
              <AppClearCache />
              <EmployerSettings />
            </AppLogout>
          }
        />
        <Route
          path="/createteam"
          element={
            <AppLogout>
              <AppClearCache />
              <CreateTeam />
            </AppLogout>
          }
        />
        <Route
          path="/listteams"
          element={
            <AppLogout>
              <AppClearCache />
              <ListTeams />
            </AppLogout>
          }
        />
        <Route
          path="/gps-incidents"
          element={
            <AppLogout>
              <AppClearCache />
              <Gps />
            </AppLogout>
          }
        />
        <Route
          path="/departments"
          element={
            <AppLogout>
              <Departments/>
            </AppLogout>
          }
        />
        <Route
          path="/departments-list"
          element={
            <AppLogout>
              <DepartmentsList/>
            </AppLogout>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
